"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.RecommendOptionType = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));

var _Label = _interopRequireDefault(require("@material-ui/icons/Label"));

var _Restore = _interopRequireDefault(require("@material-ui/icons/Restore"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Contacts = require("../../Contacts");

var _react = _interopRequireWildcard(require("react"));

var keyCodes = {
  up: 'ArrowUp',
  right: 'ArrowRight',
  down: 'ArrowDown',
  tab: 'Tab',
  enter: 'Enter'
};
var RecommendOptionType = {
  Query: 'query',
  Label: 'label',
  Contact: 'contact'
};
exports.RecommendOptionType = RecommendOptionType;

function Item(props) {
  var onClick = props.onClick,
      children = props.children,
      leftIcon = props.leftIcon,
      className = props.className,
      rightIcon = props.rightIcon,
      rest = (0, _objectWithoutProperties2["default"])(props, ["onClick", "children", "leftIcon", "className", "rightIcon"]);
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, rest, {
    className: (0, _classnames["default"])('w-full flex items-center font-semibold jutify-between py-3', className),
    onClick: onClick
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-1 min-w-0 text-left truncate"
  }, leftIcon, children), rightIcon);
}

function RecentSearchItem(props) {
  var content = props.content,
      onClick = props.onClick,
      query = props.query,
      onClose = props.onClose;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "w-full flex items-center font-semibold jutify-between p-3"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    onMouseDown: function onMouseDown(e) {
      e.preventDefault();
      onClick();
    },
    className: "flex-1 min-w-0 mr-8 text-left truncate"
  }, /*#__PURE__*/_react["default"].createElement(_Restore["default"], {
    className: "mr-7",
    style: {
      fontSize: 24
    }
  }), /*#__PURE__*/_react["default"].createElement(MatchKeyWordHight, {
    text: content,
    query: query
  })), /*#__PURE__*/_react["default"].createElement(_Close["default"], {
    onMouseDown: function onMouseDown(e) {
      e.preventDefault();
      onClose();
    },
    onClick: onClose,
    style: {
      fontSize: 24
    }
  }));
}

function LabelItem(props) {
  var content = props.content,
      onClick = props.onClick,
      query = props.query;
  return /*#__PURE__*/_react["default"].createElement(Item, {
    className: "px-3",
    onClick: onClick,
    leftIcon: /*#__PURE__*/_react["default"].createElement(_Label["default"], {
      className: "mr-7",
      style: {
        fontSize: 24
      }
    })
  }, /*#__PURE__*/_react["default"].createElement(MatchKeyWordHight, {
    className: "text-md",
    text: content,
    query: query
  }));
}

function ContactItem(props) {
  var name = props.name,
      email = props.email,
      avatar = props.avatar,
      onClick = props.onClick,
      style = props.style,
      query = props.query;
  var nameNode = (0, _react.useMemo)(function () {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "subpixel-antialiased truncate"
    }, /*#__PURE__*/_react["default"].createElement(MatchKeyWordHight, {
      className: "text-2xl ",
      text: name,
      query: query
    }));
  }, [query, name]);
  var emailNode = (0, _react.useMemo)(function () {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "subpixel-antialiased truncate"
    }, /*#__PURE__*/_react["default"].createElement(MatchKeyWordHight, {
      className: "text-lg",
      text: email,
      query: query
    }));
  }, [email, query]);
  return /*#__PURE__*/_react["default"].createElement(_Contacts.Contact, {
    name: nameNode,
    email: emailNode,
    onClick: onClick,
    style: style,
    avatar: avatar
  });
}

function Field(props) {
  var children = props.children;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "w-full cursor-pointer rounded-lg max-w-2xl"
  }, children);
}

function MatchKeyWordHight(props) {
  var text = props.text,
      query = props.query,
      className = props.className;

  if (!query) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: (0, _classnames["default"])('text-light', className)
    }, text);
  }

  var res = [];
  var str = query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  var start = text.search(new RegExp(str, 'ig'));

  if (start === -1) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: (0, _classnames["default"])('text-light', className)
    }, text);
  } else {
    var preText = text.slice(0, start);
    var matchText = text.slice(start, start + query.length);
    var suffixText = text.slice(start + query.length);
    res.push( /*#__PURE__*/_react["default"].createElement("span", {
      className: (0, _classnames["default"])('text-light', className)
    }, preText));
    res.push( /*#__PURE__*/_react["default"].createElement("span", {
      className: (0, _classnames["default"])('text-dark', className)
    }, matchText));
    res.push( /*#__PURE__*/_react["default"].createElement("span", {
      className: (0, _classnames["default"])('text-light', className)
    }, suffixText));
  }

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, res);
}

function OptionContain(props) {
  var id = props.id,
      children = props.children,
      className = props.className,
      rest = (0, _objectWithoutProperties2["default"])(props, ["id", "children", "className"]);
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    key: id,
    style: {
      paddingLeft: '20px',
      paddingRight: '20px'
    },
    className: (0, _classnames["default"])('w-full cursor-pointer hover:bg-secondary', className)
  }, rest), children);
}

function Recommend(props, ref) {
  var options = props.options,
      onSelect = props.onSelect,
      _onClose = props.onClose,
      query = props.query,
      wholeQuery = props.wholeQuery;

  var _useState = (0, _react.useState)(-1),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      selected = _useState2[0],
      setSelected = _useState2[1];

  var prevOptionsRef = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    prevOptionsRef.current = options;
  });
  var prevOptions = prevOptionsRef.current;
  (0, _react.useEffect)(function () {
    setSelected(-1);
  }, [query]);
  var onSelectKey = (0, _react.useCallback)(function () {
    if (onSelect && (options[selected] || prevOptions[selected])) {
      var _ref = options[selected] || prevOptions[selected],
          item = _ref.item,
          type = _ref.type;

      var content = item.content,
          id = item.id;

      if (type === RecommendOptionType.Query) {
        onSelect(content);
      } else if (type === RecommendOptionType.Label) {
        onSelect({
          id: id,
          name: content
        }, type);
      } else {
        onSelect(item, type);
      }
    }

    setSelected(-1);
  }, [options, selected, onSelect]);
  (0, _react.useImperativeHandle)(ref, function () {
    return {
      onSelect: onSelectKey
    };
  }, [onSelectKey]);
  (0, _react.useEffect)(function () {
    var handleArrowKeys = function handleArrowKeys(event) {
      var next = options.length - 1;

      switch (event.code) {
        case keyCodes.up:
          event.preventDefault();

          if (selected !== 0) {
            next = selected - 1;
          }

          setSelected(next);
          break;

        case keyCodes.down:
          event.preventDefault();
          next = (selected + 1) % options.length;
          setSelected(next);
          break;

        default:
          return;
      }
    };

    var handleSelect = function handleSelect(event) {
      switch (event.code) {
        case keyCodes.enter:
        case keyCodes.tab:
          event.preventDefault();
          onSelectKey();
          break;

        default:
          return;
      }
    };

    window.addEventListener('keydown', handleArrowKeys, false);
    window.addEventListener('keydown', handleSelect, false);
    return function () {
      window.removeEventListener('keydown', handleArrowKeys, false);
      window.removeEventListener('keydown', handleSelect, false);
    };
  }, [selected, onSelect, options]);
  var queryLength = options.filter(function (item) {
    return item.type === RecommendOptionType.Query;
  }).length;
  var labelLength = options.filter(function (item) {
    return item.type === RecommendOptionType.Label;
  }).length;
  var contactLength = options.filter(function (item) {
    return item.type === RecommendOptionType.Contact;
  }).length;
  if (!options.length) return null;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "z-50 absolute bg-white dark:bg-card shadow-lg rounded-lg text-2xl",
    style: {
      minWidth: '30rem',
      top: '50px'
    }
  }, /*#__PURE__*/_react["default"].createElement(Field, null, options.map(function (_ref2, index) {
    var item = _ref2.item,
        type = _ref2.type;
    var id = item.id,
        content = item.content;

    if (type === RecommendOptionType.Query) {
      return /*#__PURE__*/_react["default"].createElement(OptionContain, {
        className: {
          'bg-secondary': selected === index,
          'border-b-2': (labelLength || contactLength) && index === queryLength - 1
        },
        id: id
      }, /*#__PURE__*/_react["default"].createElement(RecentSearchItem, {
        query: wholeQuery,
        onClick: function onClick() {
          onSelect(content, type);
        },
        content: content,
        onClose: function onClose() {
          _onClose(content);
        }
      }));
    } else if (type === RecommendOptionType.Label) {
      return /*#__PURE__*/_react["default"].createElement(OptionContain, {
        id: id,
        className: {
          'bg-secondary': selected === index,
          'border-b-2': index === labelLength + queryLength - 1
        },
        onMouseDown: function onMouseDown(e) {
          e.preventDefault();
          onSelect({
            id: id,
            name: content
          }, type);
        }
      }, /*#__PURE__*/_react["default"].createElement(LabelItem, {
        query: query,
        content: content
      }));
    } else {
      return /*#__PURE__*/_react["default"].createElement(OptionContain, {
        id: id,
        className: {
          'bg-secondary': selected === index
        },
        onMouseDown: function onMouseDown(e) {
          e.preventDefault();
          onSelect(item, type);
        }
      }, /*#__PURE__*/_react["default"].createElement(ContactItem, {
        query: query,
        name: item.name,
        email: item.email,
        avatar: item.avatar
      }));
    }
  })));
}

var _default = /*#__PURE__*/(0, _react.forwardRef)(Recommend);

exports["default"] = _default;
//# sourceMappingURL=index.js.map